export const buttons = [
  { name: "Intro", url: "/docs/intro", },
  { name: "ULS Token", url: "/docs/uls-token", },
  { name: "Staking", url: "/docs/staking", },
  { name: "Roadmap", url: "/docs/roadmap", },
  { name: "Tokenomics", url: "/docs/tokenomics", },
  { name: "Links", url: "/docs/links", },
];
